
/**
 * Billing frequency
 */
export type GetPlansByProductCode200ItemBillingCycle = typeof GetPlansByProductCode200ItemBillingCycle[keyof typeof GetPlansByProductCode200ItemBillingCycle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPlansByProductCode200ItemBillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  ONE_TIME: 'ONE_TIME',
} as const;
